<template>
  <div class="container has-text-centered">
    <div v-if="logged_in">
      <p class="title">Hi {{ user.first_name }} !</p>
      <p class="subtitle"></p>
    </div>
    <div v-else>
      <section class="container is-max-desktop">
        <div class="is-flex is-flex-direction-column is-align-items-center">
          <p class="title has-text-weight-bold">Research Mentoring Platform</p>
          <a href="https://india.acm.org/" target="_blank" class="mb-4">
            <figure class="image p-0">
              <img src="/assets/logos/acm-india-council.png" style="width: 224px" alt="ACM India Council" />
            </figure>
          </a>
        </div>
        <div class="p-2 has-text-center">
          <strong>Welcome to the ACM India Research Mentoring Portal </strong> <br>
          ACM India is committed to advancing the field of computing research and education across India. This portal is designed to connect PhD students, early-career faculty, and research-driven BTech and MTech students with distinguished senior mentors who can guide and elevate their research journeys.  We aim to continually expand this network by including seasoned experts from academia, industry, and global institutions.
          <br><br>
          The platform ensures confidentiality of mentee and mentor information, with only the assigned mentor having access to the mentee's identity and registration details.  Similarly, only information that a mentor chooses to be viewable by mentees is accessible to mentees.
          Research mentoring through this portal facilitates a structured, long-term relationship, allowing mentees to benefit from sustained guidance and expertise. While ongoing mentorship is encouraged, the platform may also be used for short-term consultations based on specific needs.
          <br><br>
          <strong>For Mentees </strong> <br>
          If you're seeking expert guidance to enhance your research, sign up as a Mentee and take a step forward in your academic journey.
          <br><br>
          <strong>For Mentors</strong> <br>
          If you're an expert willing to share your knowledge and foster the next generation of researchers, sign up as a Mentor.  To prevent random signups as mentors, each mentor signup is reviewed/verified by a sub-committee of ACM India's Research Facilitation Committee.  Upon successful review, your profile will be featured in our mentor directory.
          <br>
          Join us in building a strong community of research excellence!


        </div>
        <!-- <div class="p-2 has-text-center">
          <strong>ACM India</strong> is dedicated to enhancing research in Computing within India. Through this platform,
          its objective is to offer mentorship to PhD students, as well as junior and less experienced faculty who may
          require guidance for their research. Additionally, it aims to provide mentorship to BTech and MTech students for
          their research theses. We aspire to continually broaden this network by including more experts, including those
          from industry and beyond India. <br /><br />

          The names of mentees is kept confidential - only the mentor knows the
          name of the mentee, and his/her registration.
          <br /><br />


          Research mentoring is a process in which the mentor assists the mentee over a period of time to enhance the
          quality of the mentee's research. The mentor-mentee relationship is expected to endure for a reasonable period,
          though one-time mentoring assistance is also sometimes sought and available.
          <br /><br />

          If you are interested in seeking mentorship assistance, please sign up as a
          <strong>Mentee</strong>. <br /><br />

          If you are interested in offering mentorship for research, please sign up as a <strong>Mentor</strong>. Your request will be sent
          to the administration, and upon approval, your profile will appear on the mentor page.
        </div> -->
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      logged_in: 'logged_in',
    }),
    ...mapState({
      user: 'user',
    }),
  },
};
</script>
